import * as React from 'react';
import { withDataFetchNivo } from '../hoc/withDataFetchNivo';

const ResponsiveSwarmPlot = React.lazy(() =>
  import('@nivo/swarmplot').then(module => ({
    default: module.ResponsiveSwarmPlot,
  }))
);

const SunBurstWidget: React.FC<any> = ({ data }) => {
  const {
    groups,
    valueFormat,
    value,
    valueScale,
    size,
    forceStrength,
    simulationIterations,
    borderColor,
    margin,
    axisTop,
    axisRight,
    axisBottom,
    axisLeft,
    motionStiffness,
    motionDamping,
  } = data.view;

  return (
    <React.Suspense fallback="loading...">
      <ResponsiveSwarmPlot
        data={data.data}
        groups={groups}
        value={value}
        valueFormat={valueFormat}
        valueScale={valueScale}
        size={size}
        forceStrength={forceStrength}
        simulationIterations={simulationIterations}
        borderColor={borderColor}
        margin={margin}
        axisTop={axisTop}
        axisRight={axisRight}
        axisBottom={axisBottom}
        axisLeft={axisLeft}
        motionStiffness={motionStiffness}
        motionDamping={motionDamping}
      />
    </React.Suspense>
  );
};

export default withDataFetchNivo(SunBurstWidget);
